<template>
  <section class="height-100-p">
    <el-table
      :data="blockedAccountPage.list"
      size="mini"
      tooltip-effect="dark"
      sortable
      class="dark-blue-table"
      :empty-text="$t('common.notAbleToFindRecords')"
      @sort-change="handleSortChange"
      stripe
      v-loading="blockedAccountPage.loadingSearch"
    >
      <el-table-column
        :label="$t('blockedAccounts.warehouse')"
        :min-width="2"
        align="center"
      >
        <template slot-scope="scope">
          <span>{{ scope.row.warehouse }}</span>
        </template>
      </el-table-column>
      <el-table-column
        :label="$t('blockedAccounts.shippers')"
        :min-width="5"
        align="left"
        header-align="center"
      >
        <template slot-scope="scope">
          <el-tooltip class="item" effect="dark" :content="scope.row.shipper" placement="top">
            <span>{{ scope.row.shipper }}</span>
          </el-tooltip>
        </template>
      </el-table-column>
      <el-table-column
        :label="$t('blockedAccounts.consignee')"
        :min-width="5"
        align="left"
        header-align="center"
      >
        <template slot-scope="scope">
          <el-tooltip class="item" effect="dark" :content="scope.row.consignee" placement="top">
            <span>{{ scope.row.consignee }}</span>
          </el-tooltip>
        </template>
      </el-table-column>
      <el-table-column
        :label="$t('blockedAccounts.dateFrom')"
        :min-width="2"
        align="center"
      >
        <template slot-scope="scope">
          <span>{{ scope.row.startDate | moment(dateDisplayFormat) }}</span>
        </template>
      </el-table-column>
      <el-table-column
        :label="$t('blockedAccounts.dateTo')"
        :min-width="2"
        align="center"
      >
        <template slot-scope="scope">
          <span>{{ scope.row.endDate | moment(dateDisplayFormat) }}</span>
        </template>
      </el-table-column>
      <el-table-column
        :label="$t('blockedAccounts.status')"
        :min-width="2"
        align="center"
      >
        <template slot-scope="scope">
          <span>{{ mapStatus(scope.row) }}</span>
        </template>
      </el-table-column>
      <el-table-column
        :label="$t('blockedAccounts.notes')"
        :min-width="7"
        align="left"
        header-align="center"
      >
        <template slot-scope="scope">
          <el-tooltip class="item" effect="dark" :content="getNotes(scope.row)" placement="top">
            <span>{{ scope.row.notes }}</span>
          </el-tooltip>
        </template>
      </el-table-column>
      <el-table-column
        :label="$t('common.options')"
        :min-width="2"
        align="center"
      >
        <template slot-scope="scope">
          <el-tooltip
            v-if="showDeleteButton(scope.row)"
            class="item"
            effect="dark"
            :enterable="false"
            :content="$t('common.delete')"
            placement="top-start"
          >
            <i class="el-icon-delete icon-action" @click="handleDelete(scope.row)"></i>
          </el-tooltip>
        </template>
      </el-table-column>
    </el-table>
    <div class="pagination-footer" v-show="blockedAccountPage.total > 0">
      <span class="el-pagination__total">
        <span class="el-pagination__title">{{ $t('blockedAccounts.total') }}</span>
           {{ blockedAccountPage.total }}
      </span>
      <el-pagination
        @size-change="handleSearchChangeLimit"
        :page-sizes="sizes"
        :page-size="blockedAccountPage.actualFilters.rows"
        :current-page.sync="blockedAccountPage.actualFilters.page"
        @current-change="handleSearchChangePage"
        :total="blockedAccountPage.total"
        layout="sizes, prev, pager, next, jumper"
      ></el-pagination>
    </div>
  </section>
</template>

<script>
import moment from 'moment';
import { mapActions, mapGetters } from 'vuex';
import { BLOCKED_ACCOUNTS_SEARCH, BLOCKED_ACCOUNTS_DEACTIVATION } from '@/store/actions';
import constants from '@/utils/constants';

export default {
  name: 'BlockedAccountsSummarySection',
  computed: {
    ...mapGetters([
      'blockedAccountPage'
    ]),
    sizes: () => constants.TABLES.DEFAULT_LIMIT_SIZES,
    dateDisplayFormat: () => constants.DATES.DEFAULT_DISPLAY_FORMAT,
  },
  methods: {
    ...mapActions({
      search: BLOCKED_ACCOUNTS_SEARCH,
      deactivate: BLOCKED_ACCOUNTS_DEACTIVATION,
    }),
    handleSearchChangeLimit(val) {
      this.search({
        size: val,
        page: constants.TABLES.DEFAULT_PAGE
      });
    },
    handleSearchChangePage(val) {
      this.search({ page: val });
    },
    handleSortChange({ prop, order }) {
      this.search({
        orderField: prop,
        orderDirection: constants.TABLES.ORDER_DIRECTION[order]
      });
    },
    showDeleteButton(row) {
      return row.status === constants.BLOCKED_ACCOUNTS.STATUS[1].value
          && this.$can(this.permissions.WAREHOUSE.DELETE_BLOCKED_ACCOUNT);
    },
    handleDelete(row) {
      this.$confirm(this.$t('blockedAccounts.confirmDelete'), { confirmButtonText: this.$t('common.delete') })
        .then(() => {
          const loading = this.$loading(constants.LOADING.DEFAULT_CONFIG);
          this.deactivate(row.id)
            .then((response) => {
              this.$message.success(response.message);
              this.search({});
            })
            .finally(() => {
              loading.close();
            });
        }).catch(() => {});
    },
    getNotes(row) {
      return `${row.createdBy} at ${moment(row.createdDate).format(constants.DATES.DEFAULT_DISPLAY_FORMAT_SHORT)}: ${row.notes}`;
    },
    mapStatus(row) {
      const selectedStatus = constants.BLOCKED_ACCOUNTS.STATUS.find(status => status.value === row.status);
      return (selectedStatus ? selectedStatus.label : '');
    }
  }
};
</script>
